module.exports = __webpack_public_path__ + "img/marketing-4-team.92088642.svg";